import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin( ScrollToPlugin );

const initHeroSlider = () => {
	const el = document.querySelector( '.js-hero-swiper' );
	if ( ! el ) {
		return;
	}
	const slideCount = el.querySelectorAll( '.swiper-slide' ).length;

	new Swiper( el, {
		modules: [ Navigation, Pagination, EffectFade, Autoplay ],
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 1000,
		loop: slideCount > 1,
		autoplay: slideCount > 1 ? { delay: 6000, disableOnInteraction: false } : false,
		pagination: {
			el: '.js-hero-pagination',
			clickable: true,
			bulletClass: 'pv-hero__bullet',
			renderBullet: ( index, className ) =>
				`<span class="${ className }">${ String( index + 1 ).padStart( 2, '0' ) }</span>`,
		},
		navigation: {
			prevEl: '.js-hero-prev',
			nextEl: '.js-hero-next',
		},
	} );
};

// PICK UP：SP は中央寄せ＋左右見切れのループ、Tablet 以上は 3〜4 件並べて溢れた分だけ矢印で送る
// loop はブレイクポイントで切り替えられないため、幅が変わったら作り直す
const initPickupSlider = () => {
	const el = document.querySelector( '.js-pickup-swiper' );
	if ( ! el ) {
		return;
	}
	const slideCount = el.querySelectorAll( '.swiper-slide' ).length;
	const counter = document.querySelector( '.js-pickup-count' );
	const mq = window.matchMedia( '(min-width: 768px)' );
	const pad = ( n ) => String( n ).padStart( 2, '0' );
	let swiper = null;

	// SP は「03 / 07」、複数枚並ぶときは「01–04 / 07」
	const updateCount = ( s ) => {
		if ( ! counter ) {
			return;
		}
		const perView = Math.floor( s.params.slidesPerView );
		const start = s.realIndex + 1;
		const end = Math.min( start + perView - 1, slideCount );
		const current = perView > 1 ? `${ pad( start ) }–${ pad( end ) }` : pad( start );
		counter.innerHTML = `<span class="pv-pickup__count-current">${ current }</span> / ${ pad( slideCount ) }`;
	};

	const create = () => {
		if ( swiper ) {
			swiper.destroy( true, true );
		}
		const common = {
			modules: [ Navigation ],
			watchOverflow: true,
			navigation: {
				prevEl: '.js-pickup-prev',
				nextEl: '.js-pickup-next',
			},
			on: {
				init: updateCount,
				slideChange: updateCount,
				breakpoint: updateCount,
			},
		};
		swiper = mq.matches
			? new Swiper( el, {
				...common,
				slidesPerView: 3,
				spaceBetween: 24,
				breakpoints: { 1200: { slidesPerView: 4 } },
			} )
			: new Swiper( el, {
				...common,
				slidesPerView: 1.45,
				spaceBetween: 16,
				centeredSlides: true,
				loop: slideCount >= 3,
			} );
	};

	create();
	mq.addEventListener( 'change', create );
};

$( () => {
	initHeroSlider();
	initPickupSlider();
} );
